import React from 'react';
import { Button } from "react-bootstrap";

import callbackStates from '../../constants/callbackStates';
import { formatDateTime } from '../../extensions/dateHelper';

let CallbackTable = class extends React.Component {

    _editClick(callbackEntity) {
        this.props.editClick(callbackEntity);
    }

    render() {
        const { entities: callbacks } = this.props;
        return (
            <table className="table table-hover">
                <thead>
                    <tr>
                        <td>Номер заявки</td>
                        <td>Дата создания</td>
                        <td>Телефон</td>
                        <td>Статус</td>
                        <td>Комментарий</td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {(!callbacks || callbacks.length === 0) &&
                        <tr>
                            <td colSpan="4">Здесь ничего нет</td>
                        </tr>
                    }
                    {callbacks && callbacks.map(c => {
                        const onEditClick = this._editClick.bind(this, c);
                        const state = callbackStates.find(cs => cs.Id === c.State);
                        const tableStyle = state.Id === 1 ? { background: '#ffccff' } : {};
                        return (
                            <tr style={tableStyle} key={c.Id}>
                                <td>{c.Id}</td>
                                <td>{formatDateTime(c.CreatedAt)}</td>
                                <td>{c.Phone}</td>
                                <td>{state.Name}</td>
                                <td>{c.Comment}</td>
                                <td><Button onClick={onEditClick}>Редактировать</Button></td>
                            </tr>)
                    })}
                </tbody>
            </table>);
    }
}

export default CallbackTable;


// WEBPACK FOOTER //
// ./src/components/callback/CallbackTable.jsx